export default {"src":"/_next/static/media/laboratory-pharmacy-service.f2dc7127.svg","height":217,"width":222,"blurWidth":0,"blurHeight":0};